module.exports = __webpack_public_path__ + "img/img_diagram_02.864c581f.png";